import { render, staticRenderFns } from "./cessation-type.vue?vue&type=template&id=166cb585&"
import script from "./cessation-type.vue?vue&type=script&lang=js&"
export * from "./cessation-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports